import * as React from "react";

const Sun = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={48}
        height={48}
        {...props}
    >
        <path d="M11 0v3h2V0h-2zM4.223 2.809 2.809 4.223l2.12 2.12L6.345 4.93 4.223 2.809zm15.554 0-2.12 2.12 1.413 1.415 2.121-2.121-1.414-1.414zM12 5c-3.854 0-7 3.146-7 7s3.146 7 7 7 7-3.146 7-7-3.146-7-7-7zm0 2c2.773 0 5 2.227 5 5s-2.227 5-5 5-5-2.227-5-5 2.227-5 5-5zM0 11v2h3v-2H0zm21 0v2h3v-2h-3zM4.93 17.656l-2.121 2.121 1.414 1.414 2.12-2.12-1.413-1.415zm14.14 0-1.414 1.414 2.121 2.121 1.414-1.414-2.12-2.12zM11 21v3h2v-3h-2z" />
    </svg>
);

export default Sun;
